module.exports = "query AnalyticsQuery($fromDate:Date,$toDate:Date){analytics(fromDate:$fromDate,toDate:$toDate){sessions conversionRate bounceRate}}"